export const LanguageCodes = [
  {
    lang_iso_code: 'af',
    language: 'Afrikaans',
    language_form: 'Afrikaans',
  },
  {
    lang_iso_code: 'sq',
    language: 'Albanian',
    language_form: 'Shqip',
  },
  {
    lang_iso_code: 'am',
    language: 'Amharic',
    language_form: 'አማርኛ',
  },
  {
    lang_iso_code: 'ar',
    language: 'Arabic',
    language_form: 'العربية',
  },
  {
    lang_iso_code: 'hy',
    language: 'Armenian',
    language_form: 'Հայերեն',
  },
  {
    lang_iso_code: 'az',
    language: 'Azerbaijani',
    language_form: 'Azərbaycanca',
  },
  {
    lang_iso_code: 'be',
    language: 'Belarusian',
    language_form: 'Беларуская',
  },
  {
    lang_iso_code: 'bn',
    language: 'Bengali',
    language_form: 'বাংলা',
  },
  {
    lang_iso_code: 'bi',
    language: 'Bislama',
    language_form: 'Bislama',
  },
  {
    lang_iso_code: 'bs',
    language: 'Bosnian',
    language_form: 'Bosanski',
  },
  {
    lang_iso_code: 'bg',
    language: 'Bulgarian',
    language_form: 'Български',
  },
  {
    lang_iso_code: 'my',
    language: 'Burmese',
    language_form: 'ဗမာစာ',
  },
  {
    lang_iso_code: 'ca',
    language: 'Catalan',
    language_form: 'Català',
  },
  {
    lang_iso_code: 'zh',
    language: 'Chinese',
    language_form: '中文',
  },
  {
    lang_iso_code: 'ny',
    language: 'Chichewa',
    language_form: 'Chichewa',
  },
  {
    lang_iso_code: 'cs',
    language: 'Czech',
    language_form: 'Čeština',
  },
  {
    lang_iso_code: 'da',
    language: 'Danish',
    language_form: 'Dansk',
  },
  {
    lang_iso_code: 'dv',
    language: 'Divehi',
    language_form: 'ދިވެހިބަސް',
  },
  {
    lang_iso_code: 'nl',
    language: 'Dutch',
    language_form: 'Nederlands',
  },
  {
    lang_iso_code: 'dz',
    language: 'Dzongkha',
    language_form: 'རྫོང་ཁ',
  },
  {
    lang_iso_code: 'en',
    language: 'English',
    language_form: 'English',
  },
  {
    lang_iso_code: 'et',
    language: 'Estonian',
    language_form: 'Eesti',
  },
  {
    lang_iso_code: 'fo',
    language: 'Faroese',
    language_form: 'Føroyskt',
  },
  {
    lang_iso_code: 'fi',
    language: 'Finnish',
    language_form: 'Suomi',
  },
  {
    lang_iso_code: 'fr',
    language: 'French',
    language_form: 'Français',
  },
  {
    lang_iso_code: 'ka',
    language: 'Georgian',
    language_form: 'ქართული',
  },
  {
    lang_iso_code: 'de',
    language: 'German',
    language_form: 'Deutsch',
  },
  {
    lang_iso_code: 'el',
    language: 'Greek',
    language_form: 'Ελληνικά',
  },
  {
    lang_iso_code: 'kl',
    language: 'Greenlandic',
    language_form: 'Kalaallisut',
  },
  {
    lang_iso_code: 'ckb',
    language: 'Kurdish(Sorani)',
    language_form: 'کوردیی',
  },
  {
    lang_iso_code: 'ht',
    language: 'Haitian Creole',
    language_form: 'Kreyòl Ayisyen',
  },
  {
    lang_iso_code: 'he',
    language: 'Hebrew',
    language_form: 'עברית',
  },
  {
    lang_iso_code: 'hi',
    language: 'Hindi',
    language_form: 'हिन्दी',
  },
  {
    lang_iso_code: 'hu',
    language: 'Hungarian',
    language_form: 'Magyar',
  },
  {
    lang_iso_code: 'is',
    language: 'Icelandic',
    language_form: 'Íslenska',
  },
  {
    lang_iso_code: 'id',
    language: 'Indonesian',
    language_form: 'Bahasa Indonesia',
  },
  {
    lang_iso_code: 'ga',
    language: 'Irish',
    language_form: 'Gaeilge',
  },
  {
    lang_iso_code: 'it',
    language: 'Italian',
    language_form: 'Italiano',
  },
  {
    lang_iso_code: 'ja',
    language: 'Japanese',
    language_form: '日本語',
  },
  {
    lang_iso_code: 'kk',
    language: 'Kazakh',
    language_form: 'Қазақша',
  },
  {
    lang_iso_code: 'km',
    language: 'Khmer',
    language_form: 'ខ្មែរ',
  },
  {
    lang_iso_code: 'rw',
    language: 'Kinyarwanda',
    language_form: 'Kinyarwanda',
  },
  {
    lang_iso_code: 'ko',
    language: 'Korean',
    language_form: '한국어',
  },
  {
    lang_iso_code: 'ky',
    language: 'Kyrgyz',
    language_form: 'Кыргызча',
  },
  {
    lang_iso_code: 'lo',
    language: 'Lao',
    language_form: 'ລາວ',
  },
  {
    lang_iso_code: 'la',
    language: 'Latin',
    language_form: 'Latina',
  },
  {
    lang_iso_code: 'lv',
    language: 'Latvian',
    language_form: 'Latviešu',
  },
  {
    lang_iso_code: 'lt',
    language: 'Lithuanian',
    language_form: 'Lietuvių',
  },
  {
    lang_iso_code: 'lb',
    language: 'Luxembourgish',
    language_form: 'Lëtzebuergesch',
  },
  {
    lang_iso_code: 'mk',
    language: 'Macedonian',
    language_form: 'Македонски',
  },
  {
    lang_iso_code: 'mg',
    language: 'Malagasy',
    language_form: 'Malagasy',
  },
  {
    lang_iso_code: 'ms',
    language: 'Malay',
    language_form: 'Bahasa Melayu',
  },
  {
    lang_iso_code: 'mt',
    language: 'Maltese',
    language_form: 'Malti',
  },
  {
    lang_iso_code: 'mh',
    language: 'Marshallese',
    language_form: 'Kajin M̧ajeļ',
  },
  {
    lang_iso_code: 'mfe',
    language: 'Mauritian Creole',
    language_form: 'Kreol Morisien',
  },
  {
    lang_iso_code: 'mn',
    language: 'Mongolian',
    language_form: 'Монгол',
  },
  {
    lang_iso_code: 'na',
    language: 'Nauruan',
    language_form: 'Dorerin Naoero',
  },
  {
    lang_iso_code: 'ne',
    language: 'Nepali',
    language_form: 'नेपाली',
  },
  {
    lang_iso_code: 'niu',
    language: 'Niuean',
    language_form: 'Niuē',
  },
  {
    lang_iso_code: 'no',
    language: 'Norwegian',
    language_form: 'Norsk',
  },
  {
    lang_iso_code: 'pau',
    language: 'Palauan',
    language_form: 'Belauan',
  },
  {
    lang_iso_code: 'fa',
    language: 'Persian',
    language_form: 'فارسی',
  },
  {
    lang_iso_code: 'pl',
    language: 'Polish',
    language_form: 'Polski',
  },
  {
    lang_iso_code: 'pt',
    language: 'Portuguese',
    language_form: 'Português',
  },
  {
    lang_iso_code: 'ro',
    language: 'Romanian',
    language_form: 'Română',
  },
  {
    lang_iso_code: 'ru',
    language: 'Russian',
    language_form: 'Русский',
  },
  {
    lang_iso_code: 'sm',
    language: 'Samoan',
    language_form: 'Gagana Samoa',
  },
  {
    lang_iso_code: 'sr',
    language: 'Serbian',
    language_form: 'Српски',
  },
  {
    lang_iso_code: 'si',
    language: 'Sinhala',
    language_form: 'සිංහල',
  },
  {
    lang_iso_code: 'sk',
    language: 'Slovak',
    language_form: 'Slovenčina',
  },
  {
    lang_iso_code: 'sl',
    language: 'Slovene',
    language_form: 'Slovenščina',
  },
  {
    lang_iso_code: 'so',
    language: 'Somali',
    language_form: 'Soomaaliga',
  },
  {
    lang_iso_code: 'es',
    language: 'Spanish',
    language_form: 'Español',
  },
  {
    lang_iso_code: 'sw',
    language: 'Swahili',
    language_form: 'Kiswahili',
  },
  {
    lang_iso_code: 'sv',
    language: 'Swedish',
    language_form: 'Svenska',
  },
  {
    lang_iso_code: 'tg',
    language: 'Tajik',
    language_form: 'Тоҷикӣ',
  },
  {
    lang_iso_code: 'tl',
    language: 'Tagalog',
    language_form: 'Tagalog',
  },
  {
    lang_iso_code: 'ti',
    language: 'Tigrinya',
    language_form: 'ትግርኛ',
  },
  {
    lang_iso_code: 'th',
    language: 'Thai',
    language_form: 'ไทย',
  },
  {
    lang_iso_code: 'to',
    language: 'Tongan',
    language_form: 'Lea Faka-Tonga',
  },
  {
    lang_iso_code: 'tr',
    language: 'Turkish',
    language_form: 'Türkçe',
  },
  {
    lang_iso_code: 'tk',
    language: 'Turkmen',
    language_form: 'Türkmençe',
  },
  {
    lang_iso_code: 'uk',
    language: 'Ukrainian',
    language_form: 'Українська',
  },
  {
    lang_iso_code: 'ur',
    language: 'Urdu',
    language_form: 'اردو',
  },
  {
    lang_iso_code: 'uz',
    language: 'Uzbek',
    language_form: 'Oʻzbekcha',
  },
  {
    lang_iso_code: 'vi',
    language: 'Vietnamese',
    language_form: 'Tiếng Việt',
  },
];
